export enum OptionTypeEnum {
    PARTICIPANT = "PARTICIPANT",
    ACCOMODATION = "ACCOMODATION",
    GLOBAL = "GLOBAL",
}